import { get, identity } from 'lodash/fp';

import { module } from './module';

const moduleName = 'pciProxy';

export const pciProxy = {
    moduleName,

    ...module({
        moduleSelector: get(moduleName),
        prefix: identity,
    }),
};
